import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

declare const google: any;

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss']
})
export class GoogleMapsComponent implements OnInit, AfterViewInit {
  public map: any;
  public markers: any[] = [];
  private polylines: any[] = [];
  private polygon: any;
  private geoFences: any[] = [];
  private circles: any[] = [];
  private mapClickHandles: Map<any, any> = new Map();
  @Input() zoom;
  @Input() zoomControl = true;
  @Input() mapTypeControl = true;
  @Input() scaleControl = true;
  @Input() streetViewControl = true;
  @Input() rotateControl = true;
  @Input() fullscreenControl = true;

  @ViewChild('googleMap') mapView;
  @Output() onMapInitialized: EventEmitter < any > = new EventEmitter < any > ();
  trips = new BehaviorSubject<any>(null);
  trips$ = this.trips.asObservable();
  tripsId = new BehaviorSubject<number[]>([]);
  tripsId$ = this.tripsId.asObservable();

  infoWindow;
  infoWindows: {
    infoWindow: any,
    element: any,
    typeElement: 'marker' | 'polyline',
    typeInfoWindow: 'trip' | 'driver'
  }[] = [];
  public textInfowindow = '';

  constructor() {}

 ngAfterViewInit() {
    if ((window as any).isGoogleMapsLoaded) {
      this.initialize();
      return;
    }
    const onLoaded = () => {
      this.initialize();
      window.removeEventListener('google-maps-loaded', onLoaded);
    };
    window.addEventListener('google-maps-loaded', onLoaded, false);
  }

  ngOnInit() {}

  /**
   * @description
   */
  public refreshMap() {
    google.maps.event.trigger(this.map, 'resize');
  }

  /**
   * @description
   * @returns {Promise<boolean>}
   */
  public initialize() {
    const properties = {
      center: new google.maps.LatLng(25.925788, -80.251217),
      zoom: this.zoom || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: this.zoomControl,
      mapTypeControl: this.mapTypeControl,
      scaleControl: this.scaleControl,
      streetViewControl: this.streetViewControl,
      rotateControl: this.rotateControl,
      fullscreenControl: this.fullscreenControl
    };
    this.map = new google.maps.Map(this.mapView.nativeElement, properties);
    google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
      this.onMapInitialized.emit();

    });
  }

  /**
   * Add marker to the map
   * @param location - location of the marker
   * @param icon - icon to show
   * @param title
   */
  // TODO Configuración de Labels, Se puede agregar clase en Módulo.
  public addMarker(location, icon, title?) {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
      label: {
        text: title,
        fontWeight: 'bold',
        fontSize: '12px',
        labelClass: 'my-custom-class-for-label'
      }
    });
    this.markers.push(marker);
    return marker;
  }


  public addMarkerLabel(location, icon, label, zIndex?) {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
      label: {text: label, color: 'white'},
      zIndex: zIndex ? zIndex : 0
    });
    this.markers.push(marker);
    return marker;
  }

  /**
   * Create a custom icon to marker
   * @param text
   * @param color - color to display
   * @param position
   * @returns {any} - the image of the marker
   */
  // TODO Aqui puedes aplicar estilos a los Labels.
  public customIcon(text, color, position?): any {
    let pos = -5;
    if (position !== undefined) {
      pos = pos + position;
    }
    return {
      url: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld= |' + color, // url
      scaledSize: new google.maps.Size(15, 25),
      origin: new google.maps.Point(0, 0),
      // TODO En Esta Línea configuras la posición del Label.
      labelOrigin: new google.maps.Point(8, pos),
    };
  }

  public customIcon2(text, color, position?): any {
    let pos = -5;
    if (position !== undefined) {
      pos = pos + position;
    }
    return {
      url: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld= |' + color, // url
      scaledSize: new google.maps.Size(5, 10),
      origin: new google.maps.Point(0, 0),
      // TODO En Esta Línea configuras la posición del Label.
      labelOrigin: new google.maps.Point(8, pos),
    };
  }

  public latLng(lat, lng) {
    return new google.maps.LatLng(lat, lng);
  }
  public toLatLng(location) {
    return new google.maps.LatLng(location.lat, location.lng);
  }
  /**
   * Add a polyline to the map
   * @param locations - array of lats and lngs of the path
   * @param color - color to display
   * @param weight
   * @param opacity
   */
  public addPolyline(locations, color, weight?, opacity?) {
    const polyline = new google.maps.Polyline({
      path: locations,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: opacity ? opacity : 1.0,
      strokeWeight: weight ? weight : 2,
      map: this.map
    });
    this.polylines.push(polyline);
    return polyline;
  }

  /**
   * Add a polyline to the map
   * @param locations - array of lats and lngs of the path
   * @param color - color to display
   * @param weight
   * @param opacity
   */
  public addArrowPolyline(locations, color, weight?, opacity?) {
    const polyline = new google.maps.Polyline({
      path: locations,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: opacity ? opacity : 1.0,
      strokeWeight: weight ? weight : 2,
      map: this.map
    });
    this.polylines.push(polyline);
    return polyline;
  }
  /**
   * add polyline with dots as line
   * @param locations - array of lats and lngs of the path
   * @param color - color to display
   */
  public addPolylineDots(locations, color) {
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      scale: 2
    };
    const polyline = new google.maps.Polyline({
      path: locations,
      geodesic: true,
      strokeOpacity: 0,
      strokeColor: color,
      map: this.map,
      icons: [{
        icon: lineSymbol,
        offset: '0',
        repeat: '10px'
      }]
    });
    this.polylines.push(polyline);
    return polyline;
  }

  public addPolylineDotsAutorouting(locations, color) {
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      opacity: 1,
      scale: 2
    };
    const polyline = new google.maps.Polyline({
      path: locations,
      geodesic: true,
      opacity: 0,
      strokeColor: color,
      map: this.map,
      icons: [{
        icon: lineSymbol,
        offset: '0',
        repeat: '10px'
      }]
    });
    this.polylines.push(polyline);
    return polyline;
  }

  public updatedPolyline(polyline, path, rgba?, weight?, opacity?) {
    polyline.setPath(path);
    polyline.setOptions({
      strokeColor: rgba ? rgba : 'rgb(0,0,255,0.7)',
      strokeWeight: weight ? weight : 2,
      strokeOpacity: opacity ? opacity : 1.0,
      icons: undefined,
    });
    return polyline;
  }
  /**
   * Adds a polygon to the map
   * @param locations Array of locations
   */
  public addPolygon(locations): void {
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = new google.maps.Polygon({
      paths: locations,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
    this.polygon.setMap(this.map);
  }

  public addGeoFencePolygons(data): void {
    if (this.geoFences.length > 0) {
      this.geoFences.forEach(fence => {
        fence.setMap(null);
      });
      this.geoFences = [];
    }
    data.forEach(polygon => {
      const geofence = JSON.parse(polygon.geofence);
      const path = [];
      geofence.forEach(l => {
        path.push(this.latLng(l[1], l[0]));
      });
      const p = this.getPolygon(path);
      p.setMap(this.map);
      this.geoFences.push(p);
    });
  }

  public fillGeoFences(data) {
    this.geoFences = [];
    if (data) {
      data.forEach(polygon => {
        const geofence = JSON.parse(polygon.geofence);
        const path = [];
        geofence.forEach(l => {
          path.push(this.latLng(l[1], l[0]));
        });
        const p = this.getPolygon(path);
        this.geoFences.push(p);
      });
    }
  }

  public isOnGeofences(location) {
    if (location.lat() == 25.76489219999999 && location.lng() == -80.25831140000003) {
      return true;
    }

    if (location.lat() == 25.7712156 && location.lng() == -80.25504480000001) {
      return true;
    }

    let isOn = false;
    this.geoFences.forEach(geofence => {
      if (google.maps.geometry.poly.containsLocation(location, geofence)) {
        isOn = true;
      }
    });
    return isOn;
  }

  public isOnPolygon(locations, location) {
    const polygon = new google.maps.Polygon({paths: locations});
    return google.maps.geometry.poly.containsLocation(location, polygon);
  }

  public getPolygon(locations) {
    return new google.maps.Polygon({
      paths: locations,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
  }
  /**
   * Remove all markers from the map and also from data
   */
  public clearMarkers(): void {
    this.mapClickHandles.forEach(handle => handle.remove());
    this.mapClickHandles.clear();

    this.markers.forEach((marker) => {
      google.maps.event.clearInstanceListeners(marker);
      marker.setMap(null);
    });

    this.markers = [];
  }

  /**
   * Remove all polylines from the map and also from data
   */
  public clearPolylines(): void {
    this.polylines.forEach(function (polyline) {
      polyline.setMap(null);
    });
    this.polylines = [];
  }

  /**
   * Add a circle overlay to the map
   * @param lat - latitude of the circle center
   * @param lng - longitude of the circle center
   * @param radiusMeters - radius in meters
   * @returns the created circle instance
   */
  public addCircle(lat: number, lng: number, radiusMeters: number): any {
    const circle = new google.maps.Circle({
      center: new google.maps.LatLng(lat, lng),
      radius: radiusMeters,
      strokeColor: '#4285F4',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#4285F4',
      fillOpacity: 0.35,
      map: this.map
    });
    this.circles.push(circle);
    return circle;
  }

  /**
   * Remove all circles from the map and also from data
   */
  public clearCircles(): void {
    this.circles.forEach(function (circle) {
      circle.setMap(null);
    });
    this.circles = [];
  }

  /**
   * Add to marker a custom infowindow based on html rows
   * @param marker - marker to be applied
   * @param data - array of custom content
   * @param id - in case to add buttons, put an unique id to catch click events
   * @param callbacks - array of callbacks in case you add multiple
   */
  public addMarkerCustomInfoWindowMultiLines(marker, data, id?, callbacks?): void {
    let content = '<div>';
    data.forEach(function (text) {
      content += text + '<br>';
    });
    content += '</div>';
    marker.addListener('click', function () {
      const infowindow = new google.maps.InfoWindow({
        content: content
      });
      if (id && callbacks) {
        google.maps.event.addListener(infowindow, 'domready', () => {
          callbacks.forEach(function (callback, index) {
            const btn = document.getElementById('infoWindowBtn_' + index + '_' + id);
            btn.addEventListener('click', () => {
              callback(id);
            });
          });

        });

      }
      infowindow.open( this.map, marker);
    });
  }
  /**
   * Add to marker a custom infowindow based on html rows Unique marker
   * @param marker - marker to be applied
   * @param data - array of custom content
   * @param id - in case to add buttons, put an unique id to catch click events
   * @param callbacks - array of callbacks in case you add multiple
   */
  public addMarkerCustomInfoWindowUnique(marker, data, id?, callbacks?): void {
    let content = '<div>';
    data.forEach(function (text, index) {
      content += text + '<br>';
    });
    content += '</div>';
    marker.addListener('click', function () {
      if (this.infowindow) {
        this.infowindow.close();
      }
      this.infowindow = new google.maps.InfoWindow({
        content: content
      });
      if (id && callbacks) {
        google.maps.event.addListener(this.infowindow, 'domready', () => {
          callbacks.forEach(function (callback, index) {
            const btn = document.getElementById('infoWindowBtn_' + index + '_' + id);
            btn.addEventListener('click', () => {
              callback(id);
            });
          });

        });

      }
      this.infowindow.open( this.map, marker);
    });
  }
  /**
   * Set content infowindow
   * @param data - string array of custom content
   */
  setContentInfowindow(data: string[]) {
    let content = '<div>';
    data.forEach(function (text, index) {
      content += text + '<br>';
    });
    content += '</div>';
    if (this.infoWindow) {
      this.infoWindow.setContent(content);
    }
  }
  /**
   * Adds an infowindow over a click event on any element
   * @param element Marker,polyline,polygon
   * @param data data to show
   * @param trips
   * @param id optional to multiple events
   * @param callbacks events to call on each events
   */
  public addCustomInfoWindowMultilines(element, data, trips?, id?, callbacks?) {
    // TODO incomplete style info card marker
    const content = this.generateContent(data);
    google.maps.event.addListener(element, 'click', (event) => {
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      this.infoWindow = new google.maps.InfoWindow();
      google.maps.event.addListener(this.infoWindow, 'closeclick', () => {
        this.markers.forEach((f, i) => {
          if (i > 0) {
            if (!(f.icon == 'assets/images/marker/car_green.png') && !(f.icon == 'assets/images/marker/marker-car-green.svg')) {
              f.setIcon('../../../../../assets/images/marker/blue-circle.svg');
            }
            this.trips.next([]);
          }
        });
      });
      this.infoWindow.setContent(content);
      this.markers.forEach((f, i) => {
        if (i > 0) {
          if (!(f.icon == 'assets/images/marker/car_green.png') && !(f.icon == 'assets/images/marker/marker-car-green.svg')) {
            if (element.position.lat() == f.position.lat() && element.position.lng() == f.position.lng()) {
              f.setIcon('../../../../../assets/images/marker/green-circle.svg');
            } else {

              f.setIcon('../../../../../assets/images/marker/blue-circle.svg');
            }
          }
        }

      });
      if (id && callbacks) {
        google.maps.event.addListener(this.infoWindow, 'domready', () => {
          callbacks.forEach((callback, index) => {
            const btn = document.getElementById('infoWindowBtn_' + index + '_' + id);
            btn.addEventListener('click', () => {
              callback(id);
            });
          });
        });
      }
      this.infoWindow.setPosition(event.latLng);
      this.infoWindow.open(this.map, element);
      this.trips.next(trips);
    });
  }

  generateContent(data: string[]): string {
    let content = '<div>';
    data.map((text) => {
      content += text + '<br>';
    });
    content += '</div>';
    return content;
  }

  public addCustomInfoWindow(marker, data) {
    const content = this.generateContent(data);

    google.maps.event.addListener(marker, 'click', (event) => {
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      this.infoWindow = new google.maps.InfoWindow({
        content: content
      });
      this.infoWindow.setPosition(event.latLng);
      this.infoWindow.open(this.map, marker);
    });
  }
  /**
   * Add a click listener to a marker
   * @param marker - the marker
   * @param callback - event to execute
   */
  public addMarkerClickListener(marker, callback) {
    marker.addListener('click', function () {
      callback();
    });
  }

  /**
   * Center the map over all markers added
   */
  public centerOverMarkers() {
    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach(function (marker) {
      bounds.extend(marker.position);
    });
    this.map.fitBounds(bounds);
  }

  /**
   * Center the map ver all given locations
   * @param locations - array of locations latlng
   */
  public centerOverSomeMakers(locations) {
    const bounds = new google.maps.LatLngBounds();
    locations.forEach(function (position) {
      bounds.extend(position);
    });
    this.map.fitBounds(bounds);
  }

  /**
   * Move map camera to the given locaton and zoom
   * @param lat
   * @param lng
   * @param zoom
   */
  public moveCamera(lat, lng, zoom) {
    this.map.panTo(new google.maps.LatLng(lat, lng));
    this.map.setZoom(zoom);
  }

  setZoom(zoom) {
    this.map.setZoom(zoom);
  }

  /**
   * Move a marker to a new position
   * @param marker
   * @param to
   */
  public moveMarker(marker, to) {
    const frames = [];
    const from = marker.position;
    for (let p = 0; p < 1; p += 0.01) {
      const curLat = from.lat() + p * (to.lat - from.lat());
      const curLng = from.lng() + p * (to.lng - from.lng());
      frames.push(new google.maps.LatLng(curLat, curLng));
    }
    const move = function (marker2, latlngs, index, wait, newDestination) {
      marker2.setPosition(latlngs[index]);
      if (index !== latlngs.length - 1) {
        setTimeout(function () {
          move(marker2, latlngs, index + 1, wait, newDestination);
        }, wait);
      }
    };
    move(marker, frames, 0, 20, marker.position);
  }

  /**
   * Remove a polyline from the map
   * @param polyline
   */
  public removePolyline(polyline) {
    for (let i = 0; i < this.polylines.length; i++) {
      if (this.polylines[i] === polyline) {
        this.polylines[i].setMap(null);
        this.polylines.splice(i, 1);
        break;
      }
    }
  }
  /**
   * Remove a marker from the map
   * @param marker marker
   */
  public removeMarker(marker) {
    for (let i = 0; i < this.markers.length; i++) {
      if (this.markers[i] === marker) {
        google.maps.event.clearInstanceListeners(marker);

        const handle = this.mapClickHandles.get(marker);
        if (handle) {
          handle.remove();
          this.mapClickHandles.delete(marker);
        }

        this.markers[i].setMap(null);
        this.markers.splice(i, 1);
        break;
      }
    }
  }

  /**
   * Get the distance between 2 points
   * @param from
   * @param to
   * @returns {any} - distance
   */
  public distance(from, to) {
    return google.maps.geometry.spherical.computeDistanceBetween(from, to);
  }

  /**
   * Compute a point on the boundary of a circle, given a center, a target point, and radius.
   * If the target is outside the radius, returns the closest point on the circle boundary.
   * @param center  — center of the circle (google.maps.LatLng)
   * @param point   — the target point (google.maps.LatLng)
   * @param radiusMeters — circle radius in meters
   * @returns {any} — google.maps.LatLng on the circle boundary
   */
  public computeBoundaryPoint(center: any, point: any, radiusMeters: number): any {
    const heading = google.maps.geometry.spherical.computeHeading(center, point);
    return google.maps.geometry.spherical.computeOffset(center, radiusMeters, heading);
  }

  /**
   * Add an event to an object
   * @param object
   * @param event
   */
  public trigger(object, event) {
    google.maps.event.trigger(object, event);
  }

  /**
   * Set map or null to marker, just to hide
   * @param marker marker to hide or show
   * @param tMap map or null
   */
  public setMap(marker, tMap): void {
    marker.setMap(tMap);
  }

  /**
   * Transform an encoded poyline to array of latlngs
   * @param path string of encoded polyline
   */
  public decodePolyline(path: string) {
    return google.maps.geometry.encoding.decodePath(path);
  }


  public addMarker2(location, icon, title?): void {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
      label: {
        text: title,
        fontWeight: 'bold',
        fontSize: '14px'
      },
    });
    this.markers.push(marker);
    return marker;
  }

  public addPolylineDots2(locations, color): void {
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      scale: 1.5
    };
    const polyline = new google.maps.Polyline({
      path: locations,
      geodesic: true,
      strokeOpacity: 1.0,
      strokeColor: color,
      strokeWeight: 0.5,
      map: this.map,
      icons: [{
        icon: lineSymbol,
        offset: '0',
        repeat: '10px'
      }]
    });
    this.polylines.push(polyline);
    return polyline;
  }

  openInfoWindowMarker(lat, lng) {
    this.markers.forEach(
      marker => {
        if (marker.getPosition().lat() === lat && marker.getPosition().lng() === lng) {
          google.maps.event.trigger(marker, 'click', { latLng: new google.maps.LatLng(lat, lng) });
        }
      }
    );
  }

  public updatedPathPolyline(polyline, path) {
    polyline.setPath(path);
    return polyline;
  }

  /**
   * Add a draggable marker to the map. Returns the marker instance.
   * Also sets up click on map to relocate the marker.
   */
  public addDraggableMarker(
    lat: number,
    lng: number,
    icon: string,
    onDragEnd: (pos: {latitude: number, longitude: number}) => void,
    label?: string
  ): any {
    const position = new google.maps.LatLng(lat, lng);
    const markerOpts: any = {
      position: position,
      map: this.map,
      icon: icon,
      draggable: true,
      title: 'Drag to adjust location'
    };
    if (label) {
      markerOpts.label = { text: label, color: 'white', fontWeight: 'bold', fontSize: '12px' };
    }
    const marker = new google.maps.Marker(markerOpts);
    this.markers.push(marker);

    // Listen for drag end
    marker.addListener('dragend', () => {
      const pos = marker.getPosition();
      onDragEnd({ latitude: pos.lat(), longitude: pos.lng() });
    });

    // Listen for click on map to relocate marker
    const mapClickHandle = this.map.addListener('click', (e: any) => {
      marker.setPosition(e.latLng);
      onDragEnd({ latitude: e.latLng.lat(), longitude: e.latLng.lng() });
    });
    this.mapClickHandles.set(marker, mapClickHandle);

    return marker;
  }

  public markerDrawing(location, icon) {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
    });
    this.markers.push(marker);
    return marker;
  }

  public markerDrawingWithLabel(
    location,
    icon: string,
    label: string,
    color?: string,
    animation?: boolean,
    fontWeight?: string,
    fontSize?: string,
    zIndex?: number
  ) {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
      animation: animation ? google.maps.Animation.DROP : null,
      label: {
        text: label,
        color: color ? color : 'white',
        fontWeight: fontWeight ? fontWeight : 'bold',
        fontSize: fontSize ? fontSize : '12px',
      },
      zIndex: zIndex ? zIndex : 0
    });
    this.markers.push(marker);
    return marker;
  }

  public changeMarkerIcon(marker, icon) {
    marker.setIcon(icon);
  }

  public moveMarkerNewPosition(marker, to) {
    let i = 0;
    const numDeltas = this.distance(marker.getPosition(), to) / 10;
    const delay  = 20; // milliseconds
    const from = marker.position;
    const deltaLat = (to.lat() - from.lat()) / numDeltas;
    const deltaLng = (to.lng() - from.lng()) / numDeltas;

    const move = () => {
      const newPosition = marker.position;
      const LatAndLng = this.latLng((newPosition.lat() + deltaLat), (newPosition.lng() + deltaLng));
      marker.setPosition(LatAndLng);
      if ((numDeltas - i) > 0) {
        i++;
        setTimeout(move, delay);
      } else {
        marker.setPosition(to);
      }
    };
    move();
  }

  private generateContentString(content: { title: string; body: string[] }) {
    let result = `<div>${content.title}</div><div>`;
    content.body.forEach((text) => {
      result += text + '<br>';
    });
    result += '</div>';
    return result;
  }


  addMultiLineInfoWindow(
    element: any,
    content: {
      title: string,
      body: string[],
    },
    typeElement: 'marker' | 'polyline',
    typeInfoWindow: 'trip' | 'driver',
    trips?: number[],
    animation?: boolean,
  ) {
    const infoWindow = new google.maps.InfoWindow({
      content: this.generateContentString(content),
    });

    google.maps.event.addListener(element, 'click', () => {
      const otherInfoWindow = this.infoWindows.filter(f => f.typeElement === typeElement && f.typeInfoWindow === typeInfoWindow);
      if (otherInfoWindow) {
        otherInfoWindow.forEach(f => {
          google.maps.event.trigger(f.infoWindow, 'closeclick', { latLng: f.element.getPosition() });
          f.infoWindow.close();
          if (f.typeElement === 'marker') {
            f.element.setAnimation(null);
          }
        });
        this.infoWindows.filter((f, i, a) => {
          if (f.typeElement === typeElement && f.typeInfoWindow === typeInfoWindow) {
            a.splice(i, 1);
          }
        });
      }

      infoWindow.open({
        anchor: element,
        map: this.map,
        shouldFocus: false,
      });

      if (animation && typeElement === 'marker') {
        element.setAnimation(google.maps.Animation.BOUNCE);
      }
      this.closeClick(element, infoWindow, typeElement, typeInfoWindow, trips);

      this.infoWindows.push({
        infoWindow:  infoWindow,
        element: element,
        typeElement,
        typeInfoWindow
      });
      // const currentValueTrips = this.tripsId.getValue();
      // const concatTrips = currentValueTrips.concat(trips.filter(f => !currentValueTrips.includes(f)));
      this.tripsId.next(trips);
    });

    return infoWindow;
  }

  private closeClick(
    element,
    infoWindow,
    typeElement: 'marker' | 'polyline',
    typeInfoWindow: 'trip' | 'driver',
    trips?: number[]
  ) {
    google.maps.event.addListener(infoWindow, 'closeclick', () => {
      element.setAnimation(null);
      // if (trips) {
      //   const filterTrips = this.tripsId.getValue().filter(f => !trips.includes(f));
      //   this.tripsId.next(filterTrips);
      // }
      this.infoWindows.filter((f, i, a) => {
        if (f.typeElement === typeElement && f.typeInfoWindow === typeInfoWindow) {
          a.splice(i, 1);
        }
      });
    });
  }

  openInfoWindow(element) {
    google.maps.event.trigger(element, 'click', { latLng: element.getPosition() });
  }

  closeAllInfoWindows() {
    this.infoWindows.forEach(f => {
      google.maps.event.trigger(f.infoWindow, 'closeclick', { latLng: f.element.getPosition() });
      f.infoWindow.close();
      if (f.typeElement === 'marker') {
        f.element.setAnimation(null);
      }
    });
    this.infoWindows = [];
    this.tripsId.next([]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/google-maps/google-maps.component.ts